import type { ElementMenuItem } from '../context/elementContextMenuContext';
import { BringFrontIcon, Lock03Icon, Rows03Icon, SendBackIcon } from '@milanote/roma-icons';
import { ElementContextMenuPredicates } from './elementContextMenuPredicates';

const {
    canBringToFront,
    canConnectWithLines,
    canConvertTemplate,
    canConvertToBoard,
    canConvertToDocument,
    canConvertToNote,
    canConvertToSketch,
    canGroupIntoColumn,
    canSendToBack,
    isSelectedBoardTemplate,
    willEnableLock,
} = ElementContextMenuPredicates;

const groupIntoColumn: ElementMenuItem<'groupIntoColumn'> = {
    type: 'action',
    id: 'groupIntoColumn',
    icon: Rows03Icon,
    localeKey: 'element.groupIntoColumn',
    availabilityPredicate: canGroupIntoColumn,
    onAction: (context) => context.actions.groupIntoColumn(),
};
const connectWithLines: ElementMenuItem<'connectWithLines'> = {
    type: 'action',
    id: 'connectWithLines',
    localeKey: 'element.connectWithLines',
    availabilityPredicate: canConnectWithLines,
    onAction: (context) => context.actions.connectWithLines(),
};
const convertToSketch: ElementMenuItem<'convertToSketch'> = {
    type: 'action',
    id: 'convertToSketch',
    localeKey: 'element.convertToSketchCard',
    availabilityPredicate: canConvertToSketch,
    onAction: (context) => context.actions.convertToSketch(),
};
const toggleLock: ElementMenuItem<'toggleLock'> = {
    type: 'action',
    id: 'toggleLock',
    icon: Lock03Icon,
    localeKey: (context) => `element.${willEnableLock(context) ? 'lockPosition' : 'unlockPosition'}`,
    onAction: (context) => context.actions.toggleLock(),
};
const bringToFront: ElementMenuItem<'bringToFront'> = {
    type: 'action',
    id: 'bringToFront',
    icon: BringFrontIcon,
    localeKey: 'element.bringToFront',
    availabilityPredicate: canBringToFront,
    onAction: (context) => context.actions.bringToFront(),
};
const sendToBack: ElementMenuItem<'sendToBack'> = {
    type: 'action',
    id: 'sendToBack',
    icon: SendBackIcon,
    localeKey: 'element.sendToBack',
    availabilityPredicate: canSendToBack,
    onAction: (context) => context.actions.sendToBack(),
};
const convertToTemplate: ElementMenuItem<'convertToTemplate'> = {
    type: 'action',
    id: 'convertToTemplate',
    localeKey: 'template.convertToTemplate',
    availabilityPredicate: (context) => canConvertTemplate(context) && !isSelectedBoardTemplate(context),
    onAction: (context) => context.actions.convertToTemplate(),
};
const revertTemplateToBoard: ElementMenuItem<'revertTemplateToBoard'> = {
    type: 'action',
    id: 'revertTemplateToBoard',
    localeKey: 'template.revertTemplateToBoard',
    availabilityPredicate: (context) => canConvertTemplate(context) && isSelectedBoardTemplate(context),
    onAction: (context) => context.actions.revertTemplateToBoard(),
};
const convertToNote: ElementMenuItem<'convertToNote'> = {
    type: 'action',
    id: 'convertToNote',
    localeKey: 'element.convertToNote',
    availabilityPredicate: canConvertToNote,
    onAction: (context) => context.actions.convertToNote(),
};
const convertToDocument: ElementMenuItem<'convertToDocument'> = {
    type: 'action',
    id: 'convertToDocument',
    localeKey: 'element.convertToDocument',
    availabilityPredicate: canConvertToDocument,
    onAction: (context) => context.actions.convertToDocument(),
};
const convertColumnToBoard: ElementMenuItem<'convertColumnToBoard'> = {
    type: 'action',
    id: 'convertColumnToBoard',
    localeKey: 'element.convertToBoard',
    availabilityPredicate: canConvertToBoard,
    onAction: (context) => context.actions.convertColumnToBoard(),
};

export const ELEMENT_LAYOUT_CONTEXT_MENU_ITEMS = {
    groupIntoColumn,
    connectWithLines,
    convertToSketch,
    toggleLock,
    bringToFront,
    sendToBack,
    convertToTemplate,
    revertTemplateToBoard,
    convertToNote,
    convertToDocument,
    convertColumnToBoard,
};
